var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-button',{attrs:{"loading":_vm.loading,"label":"Exportar PDF"},on:{"click":function($event){return _vm.print()}}})}
var staticRenderFns = []

export { render, staticRenderFns }